// extracted by mini-css-extract-plugin
export default {"worldCard":"World_worldCard__ZjJgb","fadeUp":"World_fadeUp__Olgfa","isActive":"World_isActive__zXLOW","worldTitle":"World_worldTitle__tOMBW","worldMeta":"World_worldMeta__zrqGb"};